<button type="button" mat-dialog-close class="close-button">
  <em class="icon-salir"></em>
</button>

<h2 mat-dialog-title class="fiscal-dialog-title">
  ¿Qué es ser residente, y/o declarar o pagar impuestos en otro país?
</h2>

<div class="mat-dialog-content-wrapper">
  <div mat-dialog-content>
    <p>
      Son aquellas personas naturales o jurídicas que tienen obligaciones tributarias en otros países en razón de que su
      actividad económica, sus ingresos y patrimonio coincide con las leyes tributarias que establece cada país para
      presentar impuestos ante la autoridad fiscal y se denominan responsables fiscales en el exterior.
    </p>
  </div>
</div>
<div mat-dialog-actions class="mat-dialog-actions">
  <button mat-dialog-close class="btn btn-degraded blue" type="button">
    Entendido
  </button>
</div>